import React from "react";

import styles from "./CustomButton.module.scss";

interface CustomButtonProps {
  text: string;
  type: "button" | "submit";
  typeStyle: "fill" | "outline";
  functionOnClick?: () => void | Promise<void>;
  icon?: string;
  altIcon?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  text,
  type,
  typeStyle,
  functionOnClick,
  icon,
  altIcon,
  style,
  disabled,
}) => {
  return (
    <button
      style={style}
      type={type}
      disabled={disabled}
      className={`${styles.btn} ${styles[typeStyle]}`}
      onClick={functionOnClick}
    >
      {icon && altIcon && <img src={icon} alt={altIcon} />}
      {text}
    </button>
  );
};

export default CustomButton;
